/**
 * @param {string} message
 */
function parseBadRequest (message) {
  const badRequestPattern = 'Bad Request:'
  const badRequestPos = message.indexOf(badRequestPattern)
  if (badRequestPos === 0) {
    const errorText = message.replace(badRequestPattern, '')
    const errorMessagesString = errorText.trim()
    return errorMessagesString.split(';').map(e => e.trim())
  }
  return []
}

export default parseBadRequest



// WEBPACK FOOTER //
// ./src/utils/parse-bad-request.js